  
 export const filterChips = [
    { id: 'EMAIL', label: 'Email' },
    { id: 'SMS', label: 'SMS' },
    { id: 'CALL', label: 'Call' },
    { id: 'WHATSAPP', label: 'WhatsApp' },
    { id: 'REPORT', label: 'Report' },
  ];

  export function isHTML(str: string): boolean {
    return /<\/?[a-z][\s\S]*>/i.test(str);
  } 

  export const handleDownload = async (attachment: any) => {
    try {
      const response = await fetch(attachment.link, { mode: 'cors' });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = attachment.name || 'download';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };
